/* eslint-disable no-console */
// fontawesomeの設定
import { dom, library } from '@fortawesome/fontawesome-svg-core'
import {
  faBuilding,
  faCalendarAlt,
  faClock,
  faEdit,
  faTrashAlt,
  faUser,
} from '@fortawesome/free-regular-svg-icons'
// fontawesomeのiconの使用したいものだけをimport
import {
  faAlignJustify,
  faAngleLeft,
  faArrowDown,
  faArrowsAlt,
  faArrowUp,
  faCamera,
  faCaretRight,
  faCheck,
  faChevronLeft,
  faChevronRight,
  faDownload,
  faEnvelopeSquare,
  faExclamationTriangle,
  faInfoCircle,
  faKey,
  faPlusCircle,
  faQuestionCircle,
  faShieldAlt,
  faSignInAlt,
  faSignOutAlt,
  faSortAlphaDown,
  faSortAlphaDownAlt,
  faSortNumericDown,
  faSortNumericDownAlt,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Amplify from 'aws-amplify'
import Axios from 'axios'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import vSelect from 'vue-select'
import 'core-js/stable'
import moment from 'moment/moment'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import DatepickerBootstrap from 'vue-bootstrap-datetimepicker'
import VueCookies from 'vue-cookies'
import VueI18n from 'vue-i18n'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import VueMarkdown from 'vue-markdown'
import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css'
import VueSwal from 'vue-swal'
import Toasted from 'vue-toasted'
import Paginate from 'vuejs-paginate'
import Vuex from 'vuex'
import En from '../locales/en.json'
import Ja from '../locales/ja.json'
import 'vue-select/dist/vue-select.css'

// 共通のscss
import './assets/styles/_common.scss'

// 共通のvue
import CommonHeader from './components/common/Header.vue'
import CommonHeaderPurchaseItem from './components/common/HeaderPurchaseItem.vue'
import CommonHeaderInventoryItem from './components/common/HeaderInventoryItem.vue'
import CommonHeaderSmallLotItem from './components/common/HeaderSmallLotItem.vue'
import CommonHeaderBaseItem from './components/common/HeaderBaseItem.vue'
import CommonSidebar from './components/common/Sidebar.vue'
import CommonTemplate from './components/common/Template.vue'
import Redirect from './components/Redirect.vue'

import { default as appConfig, default as config } from './config'
// mixinを全てimportしたcommon.jsをimport
import './mixin/common.js'
import EdiRedirect from './pages/auth/EdiRedirect.vue'
import Login from './pages/auth/Login.vue'
import LostPassword from './pages/auth/LostPassword.vue'
import LostPasswordCode from './pages/auth/LostPasswordCode.vue'
import LostPasswordDone from './pages/auth/LostPasswordDone.vue'
import Signup from './pages/auth/Signup.vue'
import SignupDone from './pages/auth/SignupDone.vue'
import InHouse from './pages/board/inHouse.vue'
import Outsourcing from './pages/board/outsourcing.vue'
import Box from './pages/box/index.vue'
import Card from './pages/card/index.vue'
import CompanyTranslation from './pages/company-translation/index.vue'
import Company from './pages/company/index.vue'
import Constitution from './pages/constitution/index.vue'
import SettingMenu from './pages/setting-menu/index.vue'
import CustomForm from './pages/custom-form/index.vue'
import CustomerGroup from './pages/customer-group/index.vue'
import Department from './pages/department/index.vue'
import Facility from './pages/facility/index.vue'
import Factory from './pages/factory/index.vue'
import Import from './pages/import/index.vue'
import InventoryImportEdit from './pages/inventory-import/edit.vue'
import InventoryImport from './pages/inventory-import/index.vue'
import InventoryKind from './pages/inventory-kind/index.vue'
import InventoryMaster from './pages/inventory-master/index.vue'
import LotImportEdit from './pages/lot-import/edit.vue'
import LotImport from './pages/lot-import/index.vue'
import Menu from './pages/menu/Menu.vue'
import RedirectPage from './pages/redirect/index.vue'
import OrderImportEdit from './pages/order-import/edit.vue'
import OrderImport from './pages/order-import/index.vue'
import PartnerDetail from './pages/partner/detail.vue'
import EdiApprove from './pages/partner/EdiApprove.vue'
import Partner from './pages/partner/index.vue'
import PartnerImportEdit from './pages/partner-import/edit.vue'
import PartnerImport from './pages/partner-import/index.vue'
import ProductImportEdit from './pages/product-import/edit.vue'
import ProductImport from './pages/product-import/index.vue'
import ProductProcessImportEdit from './pages/product-process-import/edit.vue'
import ProductProcessImport from './pages/product-process-import/index.vue'
import ProductDetail from './pages/product/detail.vue'
import Product from './pages/product/index.vue'
import ProductRegister from './pages/product/product.vue'
import ProjectImportEdit from './pages/project-import/edit.vue'
import ProjectImport from './pages/project-import/index.vue'
import CustomBusinessForm from './pages/custom-business-form/index.vue'
import ShipDeliverImportEdit from './pages/ship-deliver-import/edit.vue'
import ShipDeliverImport from './pages/ship-deliver-import/index.vue'
import ShipImportEdit from './pages/ship-import/edit.vue'
import ShipImport from './pages/ship-import/index.vue'
import Space from './pages/space/index.vue'
import StructureImportEdit from './pages/structure-import/edit.vue'
import StructureImport from './pages/structure-import/index.vue'
import SupplyDeliverImportEdit from './pages/supply-deliver-import/edit.vue'
import SupplyDeliverImport from './pages/supply-deliver-import/index.vue'
import SupplyExtraImportEdit from './pages/supply-extra-import/edit.vue'
import SupplyExtraImport from './pages/supply-extra-import/index.vue'
import User from './pages/user/index.vue'
import './quasar'
import store from './store'


moment.updateLocale('ja', {months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']})


Amplify.configure({
  Auth: {
    region: config.Region,
    userPoolId: config.UserPoolId,
    userPoolWebClientId: config.ClientId,
    identityPoolId: config.IdentityPoolId,
  },
  Storage: {
    AWSS3: {
      bucket: config.Bucket, // REQUIRED -  Amazon S3 bucket
      region: config.BucketRegion, // OPTIONAL -  Amazon service region
    },
  },
})


// axios設定
Vue.prototype.$axios = Axios
Vue.prototype.$appConfig = appConfig


dom.watch()
library.add(
  faSortNumericDownAlt,
  faSortNumericDown,
  faSortAlphaDownAlt,
  faSortAlphaDown,
  faCheck,
  faClock,
  faInfoCircle,
  faExclamationTriangle,
  faDownload,
  faSignOutAlt,
  faBuilding,
  faUser,
  faKey,
  faSignInAlt,
  faCaretRight,
  faAngleLeft,
  faEnvelopeSquare,
  faQuestionCircle,
  faShieldAlt,
  faCalendarAlt,
  faTimesCircle,
  faAlignJustify,
  faArrowsAlt,
  faArrowUp,
  faArrowDown,
  faChevronLeft,
  faChevronRight,
  faTrashAlt,
  faPlusCircle,
  faEdit,
  faCamera,
)

Vue.config.productionTip = false
Vue.use(VueCookies)
Vue.use(Vuex)
Vue.use(VueI18n)
Vue.use(VueSwal)
Vue.use(BootstrapVue)
// トーストの設定
Vue.use(Toasted, {
  type: 'error',
  position: 'top-center',
  text: 'キャンセル',
  duration: 10000,
  action: {
    text: '×',
    onClick: function(e, toastObject) {
      toastObject.goAway(0)
    },
  },
})

Vue.component('common-header', CommonHeader)
Vue.component('common-header-purchase-item', CommonHeaderPurchaseItem)
Vue.component('common-header-inventory-item', CommonHeaderInventoryItem)
Vue.component('common-header-smalllot-item', CommonHeaderSmallLotItem)
Vue.component('common-header-base-item', CommonHeaderBaseItem)
Vue.component('common-sidebar', CommonSidebar)
Vue.component('common-template', CommonTemplate)
Vue.component('redirect', Redirect)

Vue.component('paginate', Paginate)
Vue.component('date-picker', DatepickerBootstrap)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('vue-simple-suggest', VueSimpleSuggest)

Vue.component('login', Login)
Vue.component('lost-password', LostPassword)
Vue.component('lost-password-code', LostPasswordCode)
Vue.component('lost-password-done', LostPasswordDone)
Vue.component('signup', Signup)
Vue.component('signup-done', SignupDone)
Vue.component('edi-redirect', EdiRedirect)
Vue.component('menupage', Menu)
Vue.component('redirect-page', RedirectPage)

Vue.component('partner', Partner)
Vue.component('partner-import', PartnerImport)
Vue.component('partner-import-edit', PartnerImportEdit)
Vue.component('partner-detail', PartnerDetail)
Vue.component('edi-approve', EdiApprove)
Vue.component('constitution', Constitution)
Vue.component('setting-menu', SettingMenu)
Vue.component('inventory-master', InventoryMaster)
Vue.component('product', Product)
Vue.component('product-register', ProductRegister)
Vue.component('product-detail', ProductDetail)
Vue.component('custom-business-form', CustomBusinessForm)
Vue.component('factory', Factory)
Vue.component('department', Department)
Vue.component('user-list', User)
Vue.component('company-translation', CompanyTranslation)
Vue.component('space', Space)
Vue.component('company', Company)
Vue.component('box', Box)
Vue.component('card', Card)
Vue.component('inventory-kind', InventoryKind)
Vue.component('customer-group', CustomerGroup)
Vue.component('facility', Facility)
Vue.component('order-import', OrderImport)
Vue.component('order-import-edit', OrderImportEdit)
Vue.component('product-import', ProductImport)
Vue.component('product-import-edit', ProductImportEdit)
Vue.component('product-process-import', ProductProcessImport)
Vue.component('product-process-import-edit', ProductProcessImportEdit)
Vue.component('project-import', ProjectImport)
Vue.component('project-import-edit', ProjectImportEdit)
Vue.component('inventory-import', InventoryImport)
Vue.component('inventory-import-edit', InventoryImportEdit)
Vue.component('structure-import', StructureImport)
Vue.component('structure-import-edit', StructureImportEdit)
Vue.component('ship-import', ShipImport)
Vue.component('ship-import-edit', ShipImportEdit)
Vue.component('ship-deliver-import', ShipDeliverImport)
Vue.component('ship-deliver-import-edit', ShipDeliverImportEdit)
Vue.component('supply-deliver-import', SupplyDeliverImport)
Vue.component('supply-deliver-import-edit', SupplyDeliverImportEdit)
Vue.component('supply-extra-import', SupplyExtraImport)
Vue.component('supply-extra-import-edit', SupplyExtraImportEdit)
Vue.component('lot-import', LotImport)
Vue.component('lot-import-edit', LotImportEdit)
Vue.component('import', Import)
Vue.component('in-house', InHouse)
Vue.component('outsourcing', Outsourcing)
Vue.component('custom-form', CustomForm)
Vue.component('vue-markdown', VueMarkdown)
Vue.component('v-select', vSelect)

Vue.component('loading', Loading)

// エラー表示の設定
Vue.config.errorHandler = (err, vm, info) => {
  console.log('error!!!')
  console.log(err)
  console.log(vm)
  console.log(info)
}

// 言語プログラム
const i18n = new VueI18n({
  locale: (window.navigator.language || window.navigator.userLanguage || window.navigator.browserLanguage).substr(0, 2),
  fallbackLocale: 'ja',
  messages: {
    ja: Ja,
    en: En,
  },
  silentTranslationWarn: true,
})

const init = async() => {
  const nonAuthPaths = [
    '/auth/login.html',
    '/auth/lostpassword.html',
    '/auth/lostpasswordcode.html',
    '/auth/lostpassworddone.html',
    '/auth/signup.html',
    '/auth/trial.html',
    '/auth/signupdone.html',
    '/auth/edi.html',
    '/card/index.html',
  ]
  const path = window.location.pathname.replace(/^\/base/, '')
  if (nonAuthPaths.indexOf(path) !== -1) {
    new Vue({
      el: '#app',
      store: store,
      i18n: i18n,
    })
  } else {
    await store.dispatch('auth/user')

    i18n.locale = store.getters['auth/userdata'].languageCode
    localStorage.lang = store.getters['auth/userdata'].languageCode

    // 言語データの読み込み
    const res = await Axios.get(
      `${appConfig.CommonApiUrl}/messages`,
      {
        headers: {
          Authorization: store.getters['auth/authorization'] ? store.getters['auth/authorization'] : null,
        },
        params: {
          languageCode: store.getters['auth/userdata'].languageCode,
        },
      }
    )
    let tdata = {}
    for (const key in res.data) {
      if (res.data.hasOwnProperty(key)) {
        if (!res.data[key]) {
          tdata[key] = key
        } else {
          tdata[key] = res.data[key]
        }
      }
    }
    // 言語データ反映
    i18n.mergeLocaleMessage(i18n.locale, tdata)
    i18n.setLocaleMessage(i18n.messages[i18n.locale])

    new Vue({
      el: '#app',
      store: store,
      i18n: i18n,
    })
  }
}

init()
